import * as React from 'react';
import Icon from '../../widgets/Icons';
import { OnboardingSections } from '../../constants';

export type Props = {
  title: OnboardingSections;
  children?: any;
  completed: boolean;
};

export const OnboardingSection = (props: Props) => {
  const { title, children, completed } = props;

  return (
    <div className="onboarding-section">
      <div className="title-section d-flex">
        {completed ? (
          <Icon.CheckCircle
            data-cy="check-circle-svg"
            style={{ height: '35px', width: '35px', fill: '#23618E' }}
          />
        ) : (
          <Icon.CircleSolid
            data-cy="circle-solid-svg"
            style={{ height: '35px', width: '35px', fill: '#bbb' }}
          />
        )}
        <h2 className="ml-3">{title}</h2>
      </div>
      <div
        className={`${
          completed ? 'completed-content' : 'incomplete-content'
        } w-100`}
      >
        {children}
      </div>
    </div>
  );
};
